import React from "react";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";

import ChipArray from "../components/chip_array";
import ConfirmationButton from "../components/confirmation_button";
import DefaultTable from "../components/table";
import DynamicSnackbar from "../components/dynamic_snackbar";
import LoadingBackdrop from "../components/loading_backdrop";
import issueStateUpdateRequest from "../components/panel_update_helper";

class AnnouncementsPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      dynamicSnackbar: {
        open: false,
        severity: null,
        message: null,
        url: null,
      },
      draftMessage: {
        title: null,
        subtitle: null,
        body: null,
        imageURL: null,
        iconURL: null,
        linkURL: null,
        startTime: null,
        endTime: null,
        expiryTime: null,
        filterConditions: null,
        rewards: null,
      },
      filterConditionsOptions: [],
      rewardOptions: [],
      publishedAnnouncementsTable: {
        messageIDs: [],
        headers: [],
        values: [],
        urls: [],
      },
    };
  }

  render() {
    let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    return (
      <div className="panel server-panel">
        <LoadingBackdrop open={this.state.loading} />
        <DynamicSnackbar
          open={this.state.dynamicSnackbar.open}
          severity={this.state.dynamicSnackbar.severity}
          message={this.state.dynamicSnackbar.message}
          url={this.state.dynamicSnackbar.url}
          handleClose={() => {
            this.setState({
              dynamicSnackbar: { ...this.state.dynamicSnackbar, open: false },
            });
          }}
        />
        <h1>Announcements</h1>
        <div
          className="panel-section"
          style={{ display: "flex", flexDirection: "column", gap: "0.4rem" }}
        >
          <TextField
            id="message-title"
            label="Title"
            variant="outlined"
            className="textfield"
            component={Paper}
            elevation={1}
            value={this.state.draftMessage.title || ""}
            onChange={(event) =>
              this.updateDraftMessageProperty("title", event.target.value)
            }
          />

          <TextField
            id="message-subtitle"
            label="Subtitle"
            variant="outlined"
            className="textfield"
            component={Paper}
            elevation={1}
            value={this.state.draftMessage.subtitle || ""}
            onChange={(event) =>
              this.updateDraftMessageProperty("subtitle", event.target.value)
            }
          />

          <TextField
            id="message-body"
            label="Body"
            variant="outlined"
            className="textfield"
            component={Paper}
            elevation={1}
            multiline
            value={this.state.draftMessage.body || ""}
            onChange={(event) =>
              this.updateDraftMessageProperty("body", event.target.value)
            }
          />

          <TextField
            id="message-image-url"
            label="Image URL"
            variant="outlined"
            className="textfield"
            component={Paper}
            elevation={1}
            value={this.state.draftMessage.imageURL || ""}
            onChange={(event) =>
              this.updateDraftMessageProperty("imageURL", event.target.value)
            }
          />

          <TextField
            id="message-icon-url"
            label="Icon URL"
            variant="outlined"
            className="textfield"
            component={Paper}
            elevation={1}
            value={this.state.draftMessage.iconURL || ""}
            onChange={(event) =>
              this.updateDraftMessageProperty("iconURL", event.target.value)
            }
          />

          <TextField
            id="message-link-url"
            label="Link URL"
            variant="outlined"
            className="textfield"
            component={Paper}
            elevation={1}
            value={this.state.draftMessage.linkURL || ""}
            onChange={(event) =>
              this.updateDraftMessageProperty("linkURL", event.target.value)
            }
          />

          <TextField
            id="message-start-time"
            value={this.state.draftMessage.startTime || ""}
            label={"Start Time (" + timezone + ")"}
            type="datetime-local"
            className="textfield"
            component={Paper}
            elevation={1}
            InputLabelProps={{
              shrink: true,
            }}
            onChange={(event) =>
              this.updateDraftMessageProperty("startTime", event.target.value)
            }
          />

          <TextField
            id="message-end-time"
            value={this.state.draftMessage.endTime || ""}
            label={"End Time (" + timezone + ")"}
            type="datetime-local"
            className="textfield"
            component={Paper}
            elevation={1}
            InputLabelProps={{
              shrink: true,
            }}
            onChange={(event) =>
              this.updateDraftMessageProperty("endTime", event.target.value)
            }
          />

          <TextField
            id="message-expiry-time"
            value={this.state.draftMessage.expiryTime || ""}
            label={"Expiry Time (" + timezone + ")"}
            type="datetime-local"
            className="textfield"
            component={Paper}
            elevation={1}
            InputLabelProps={{
              shrink: true,
            }}
            onChange={(event) =>
              this.updateDraftMessageProperty("expiryTime", event.target.value)
            }
          />

          <ChipArray
            title="Filter Conditions"
            children_field_name="filter condition"
            selection_options={this.state.filterConditionsOptions}
            onChange={(value) =>
              this.updateDraftMessageProperty("filterConditions", value)
            }
          />

          <ChipArray
            title="Rewards"
            children_field_name="reward"
            dialogSelectionValueIsInt={true}
            selection_options={this.state.rewardOptions}
            onChange={(value) =>
              this.updateDraftMessageProperty("rewards", value)
            }
          />

          <ConfirmationButton
            onClick={() => this.handleSubmitButtonClick()}
            title="Submit Announcment"
            confirmationMessage="Confirming will create a new inbox announcement message"
          >
            Submit
          </ConfirmationButton>
        </div>

        <div className="panel-section">
          <DefaultTable
            tableHeaders={this.state.publishedAnnouncementsTable.headers}
            tableRows={this.state.publishedAnnouncementsTable.values}
            tableUrls={this.state.publishedAnnouncementsTable.urls}
            deletable
            onRowDelete={this.handleMessageDeleteButtonClick}
          />
        </div>
      </div>
    );
  }

  updateDraftMessageProperty(property, value) {
    let draftMessage = { ...this.state.draftMessage };
    draftMessage[property] = value;
    this.setState({ draftMessage: draftMessage });
  }

  handleSubmitButtonClick = async () => {
    await issueStateUpdateRequest(
      this,
      "/announcements_panel/submit_message",
      Object.fromEntries(
        Object.entries(this.state.draftMessage).filter(
          ([key, val]) => val !== null
        )
      ),
      "post"
    );
  };

  handleMessageDeleteButtonClick = async (messageIndex) => {
    let messageID =
      this.state.publishedAnnouncementsTable.messageIDs[messageIndex];
    await issueStateUpdateRequest(
      this,
      "/announcements_panel/delete_message",
      { messageID: messageID },
      "post"
    );
  };

  async componentDidMount() {
    await issueStateUpdateRequest(
      this,
      "/announcements_panel/get_announcements_info"
    );
  }
}

export default AnnouncementsPanel;
